import React from "react";
import { useState } from "react";
import "./nav.css";
import { BsHouseDoor } from "react-icons/bs";
import { BiUserCircle } from "react-icons/bi";
import { RiBook2Line } from "react-icons/ri";
import { MdOutlineMedicalServices } from "react-icons/md";
import { TbMessage2Up } from "react-icons/tb";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");
  return (
    <nav>
      <a
        href="#"
        onClick={() => setActiveNav("#")}
        className={activeNav === "#" ? "active" : " "}
      >
        <BsHouseDoor />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav("#about")}
        className={activeNav === "#about" ? "active" : ""}
      >
        <BiUserCircle />
      </a>
      <a
        href="#experience"
        // To change the active Class 
        onClick={() => setActiveNav("#experience")}
        className={activeNav === "#experience" ? "active" : " "}
      >
        <RiBook2Line />
      </a>
      <a
        href="#services"
        onClick={() => setActiveNav("#services")}
        className={activeNav === "#services" ? "active" : " "}
      >
        <MdOutlineMedicalServices />
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav === "#contact" ? "active" : " "}
      >
        <TbMessage2Up />
      </a>
    </nav>
  );
};

export default Nav;
